<template>
  <e-dialog
    dialog-title="添加供应商"
    :center-dialog-visible="addSupplierVisible"
    popup-width="1080px"
    destroy-close
    modal-append-to-body
    @updateVisible="cancelHandle"
    @resetPopupData="cancelHandle"
    @submitPopupData="setSelectCompany"
  >
    <div class="select-products">
      <div v-if="currentIndex === 0" class="search-box">
        <el-form ref="cListQuery" :model="cListQuery" size="small" class="search-form">
          <el-row>
            <el-col :span="12">
              <el-form-item label="供应商名称：" label-width="130px" prop="">
                <el-input v-model="cListQuery.companyName" placeholder="供应商名称" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="法人信用认证：" label-width="130px" prop="">
                <el-select v-model="cListQuery.creditGrade" placeholder="请选择">
                  <el-option
                    v-for="item in creditArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="易派客标准指数：" label-width="130px" prop="" class="range">
                <el-input
                  v-model="cListQuery.scoreAllStart"
                  oninput="
                  value = value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')
                "
                ></el-input>
                <span>-</span>
                <el-input
                  v-model="cListQuery.scoreAllEnd"
                  oninput="
                  value = value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')
                "
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div style="margin: 6px 0 0 10px">
                <el-checkbox v-model="cListQuery.onlyQueryCooperative">易专采供应商资源</el-checkbox>
              </div>
            </el-col>
            <el-col :span="24">
              <el-form-item label="商品目录：" label-width="130px" prop="categoryIds">
                <!--  style="width: 812px; height: 34px; overflow: hidden" -->
                <el-cascader
                  v-model="cListQuery.categoryIds"
                  style="width: 812px; height: 34px; overflow: hidden"
                  placeholder="可搜索商品目录"
                  :options="options"
                  :props="{ multiple: true, value: 'categoryId', label: 'categoryName', children: 'children' }"
                  filterable
                  collapse-tags
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="search-btn">
          <eui-btn type="weak" @click="handleReset">重 置</eui-btn>
          <eui-btn @click="handleSearch">搜 索</eui-btn>
        </div>
      </div>
      <div class="table-wrap" :style="{ marginTop: currentIndex === 1 ? '26px' : 0 }">
        <div class="table-left">
          <div class="list-box">
            <!-- :checkSelectable="checkSelectable" -->
            <ETableList
              ref="leftTable"
              :table-data="leftTableData"
              :table-label="leftTableLabel"
              :loading="tableLoading"
              max-height="252"
              height="252px"
              row-key="companyId"
              selection-show
              @handleSelectionChange="leftHandleSelectionChange"
            >
              <template #scoreAll="{ scope }">
                <eui-btn type="text" @click="companyDetail(scope.row.companyId)">查看详情</eui-btn>
              </template>
              <template #compliance="{ scope }">
                <el-rate v-model="scope.row.compliance" disabled text-color="#ee9900"></el-rate>
              </template>
              <template #innovationEvaluate="{ scope }">
                <el-rate v-model="scope.row.innovationEvaluate" disabled text-color="#ff9900"></el-rate>
              </template>
            </ETableList>
          </div>

          <div class="pagination">
            <el-pagination
              :pager-count="5"
              layout="total, prev, pager, next"
              :current-page="cListQuery.pageNum"
              :total="total"
              :page-size.sync="cListQuery.pageSize"
              prev-text="上一页"
              next-text="下一页"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
        <div class="table-center">
          <eui-btn @click="addSelectedList">
            添加
            <eui-icon icon="eicon-arrow-right"></eui-icon>
          </eui-btn>
          <eui-btn style="margin: 10px 0 0 0" @click="deleteCompany">
            <eui-icon icon="eicon-arrow-left"></eui-icon>
            删除
          </eui-btn>
        </div>
        <div class="table-right">
          <p v-if="rightTableData.length < 3" class="sup-tips">注：当前选择邀请询价供应商少于3家</p>
          <div class="list-box">
            <ETableList
              ref="rightTable"
              :table-data="rightTableData"
              :table-label="rightTableLabel"
              max-height="252"
              height="252px"
              row-key="companyId"
              selection-show
              @handleSelectionChange="rightHandleSelectionChange"
            ></ETableList>
          </div>
        </div>
      </div>
    </div>
    <e-dialog
      dialog-title="产品质量评价详情"
      :center-dialog-visible="detailVisible"
      popup-width="560px"
      show-close-btn
      :show-btn="false"
      @updateVisible="detailVisible = false"
      @resetPopupData="detailVisible = false"
      @submitPopupData="detailVisible = false"
    >
      <ETableList :table-data="detailTableData" :table-label="detailTableLabel"></ETableList>
      <div class="pagination">
        <el-pagination
          :pager-count="5"
          layout="total, prev, pager, next"
          :current-page="detailQuery.pageNum"
          :total="detailTotal"
          :small="true"
          :page-size.sync="detailQuery.pageSize"
          @size-change="detailHandleSizeChange"
          @current-change="detailHandleCurrentChange"
        ></el-pagination>
      </div>
    </e-dialog>
  </e-dialog>
</template>

<script>
import Api from '@/modules/projectA/api/enquiry';
import ETableList from '@/modules/projectA/components/common/e-table-list';
import EDialog from '@/modules/projectA/components/common/e-dialog';
import mixins from './mixins/addSupplierDia';

export default {
  components: {
    ETableList,
    EDialog,
  },
  mixins: [mixins],
  props: {
    addSupplierVisible: {
      type: Boolean,
      default: false,
    },
    companyTableList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      currentIndex: 0,
      cloneSupplierForm: {},
      // 公司列表参数
      tableLoading: false,
      leftTableData: [],
      total: 0,

      // 详情列表参数
      detailTableData: [],
      detailLoading: false,
      detailQuery: {
        pageNum: 1,
        pageSize: 10,
        companyId: -1,
      },
      cListQuery: {
        companyName: '',
        pageNum: 1,
        pageSize: 10,
        favoritesType: 1,
        scoreAllStart: '',
        scoreAllEnd: '',
        creditGrade: '',
        onlyQueryCooperative: false,
        categoryIds: [],
        categoryIdList: [],
        emergency: 1,
      },
      detailTotal: 0,

      // 已选供应商列表
      rightTableData: [],

      // 内层dia
      detailVisible: false,
      leftSelectedList: [],
      rightSelectedList: [],
      options: [],
    };
  },
  watch: {
    addSupplierVisible(newVal) {
      if (newVal) {
        this.cloneSupplierForm = this.$options.data().cListQuery;
        this.currentIndex = 0;
        this.getList(this.cListQuery);
        this.rightTableData = [...this.companyTableList];
        this.getCategoryList();
      }
    },
  },
  methods: {
    async getCategoryList() {
      const params = {
        isStandard: 2,
      };
      const res = await Api.transferCategoryTree(params);
      if (res.code === '200') {
        this.options = res.data;
      }
    },
    leftHandleSelectionChange(val) {
      this.leftSelectedList = val;
    },
    rightHandleSelectionChange(val) {
      this.rightSelectedList = val;
    },
    deleteCompany() {
      const companyIds = this.rightSelectedList.map((item) => item.companyId);

      this.rightTableData = this.rightTableData.filter((item) => !companyIds.includes(item.companyId));

      this.$nextTick(this.$refs.rightTable.$refs.table.clearSelection());
    },
    // 添加供应商
    addSelectedList() {
      this.rightTableData = [...this.rightTableData, ...this.leftSelectedList];
      const obj = {};
      this.rightTableData = this.rightTableData.reduce(function (item, next) {
        obj[next.companyId] ? '' : (obj[next.companyId] = true && item.push(next));
        return item;
      }, []);
    },
    // 获取全部 列表数据
    async getList(params) {
      this.tableLoading = true;
      await Api.queryCompanyCreditGradePage(params).then((res) => {
        this.tableLoading = false;
        if (res.code === '200') {
          const list = res.data?.records;
          list.forEach((item) => {
            item.complianceAlias = item.compliance;
            item.innovationEvaluateAlias = item.innovationEvaluate;
            item.innovationEvaluate = item.innovationEvaluate
              ? this.innovationEvaluate(Number(item.innovationEvaluate))
              : item.innovationEvaluate;

            item.compliance = item.compliance ? this.compliance(Number(item.compliance)) : item.compliance;
          });
          this.leftTableData = [...list];
          this.total = res.data?.total;
          this.$nextTick(this.$refs.leftTable.$refs.table.clearSelection());
        }
      });
    },
    // 处理市场业绩
    innovationEvaluate(score) {
      switch (true) {
        case score >= 0 && score < 10:
          return 1;
        case score >= 10 && score < 20:
          return 2;
        case score >= 20 && score < 40:
          return 3;
        case score >= 40 && score < 60:
          return 4;
        default: // 当 score >= 60
          return 5;
      }
    },
    // 履约
    compliance(score) {
      return score / 5;
    },

    // 获取公司详情数据
    async getCompanyDetailList(params) {
      this.detailLoading = true;
      await Api.queryCompanyProductGradePage(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          console.log(res, '收藏列表数据');
          const list = res.data?.records;
          this.detailTableData = [...list];
          this.detailTotal = res.data?.total;
        }
      });
    },
    // 内层弹窗
    companyDetail(companyId) {
      this.detailQuery.companyId = companyId;
      this.detailVisible = true;
      this.getCompanyDetailList(this.detailQuery);
    },
    // 搜索
    handleSearch() {
      console.log(this.cListQuery);
      if (this.cListQuery.categoryIds.length) {
        this.cListQuery.categoryIdList = this.cListQuery.categoryIds.map((subArray) => subArray[subArray.length - 1]);
      }
      this.cListQuery.pageNum = 1;
      if (this.currentIndex === 0) {
        this.getList(this.cListQuery);
      } else {
        this.getSupplierList(this.cListQuery);
      }
    },
    // 重置
    handleReset() {
      console.log({ ...this.cloneSupplierForm });
      this.cListQuery = { ...this.cloneSupplierForm };
      if (this.currentIndex === 0) {
        this.getList(this.cListQuery);
      } else {
        this.getSupplierList(this.cListQuery);
      }
    },
    // 切换
    handleTab(index) {
      this.currentIndex = index;
      this.leftTableData = [];

      this.cListQuery = { ...this.cloneSupplierForm };
      if (this.currentIndex === 0) {
        this.getList(this.cListQuery);
      } else {
        this.cListQuery.favoritesType = 1;
        this.getSupplierList(this.cListQuery);
      }
    },
    // 获取 收藏 列表数据 querySupplierCollectionPageInfo
    async getSupplierList(params) {
      this.tableLoading = true;
      await Api.querySupplierCollectionPageInfo(params).then((res) => {
        this.tableLoading = false;
        if (res.code === '200') {
          const { data } = res;
          const tableList = data.collectionData?.records;
          tableList.forEach((item) => {
            item.companyName = item.favoritesName;
            item.companyId = item.supplierCompanyId;
          });

          this.leftTableData = [...data.collectionData?.records];
          this.total = data.collectionData?.total;
        }
      });
    },
    handleCurrentChange(val) {
      this.cListQuery.pageNum = val;
      if (this.currentIndex === 0) {
        this.getList(this.cListQuery);
      } else {
        this.getSupplierList(this.cListQuery);
      }
    },
    handleSizeChange(val) {
      this.cListQuery.pageNum = 1;
      this.cListQuery.pageSize = val;
      this.getList(this.cListQuery);
    },
    cancelHandle() {
      this.cListQuery = { ...this.cloneSupplierForm };
      this.$emit('update:addSupplierVisible', false);
    },
    // 点击确定 获取到选择的商品
    setSelectCompany() {
      this.$emit('getSelectCompany', this.rightTableData);
      this.$emit('update:addSupplierVisible', false);
    },
    detailHandleCurrentChange(val) {
      this.detailQuery.pageNum = val;
      this.getCompanyDetailList(this.detailQuery);
    },
    detailHandleSizeChange(val) {
      this.detailQuery.pageSize = val;
      this.detailQuery.pageNum = 1;
      this.getCompanyDetailList(this.detailQuery);
    },
  },
};
</script>
<style lang="scss">
.select-products {
  .table-wrap {
    width: 100%;
    display: flex;
    .table-left {
      width: 520px;
    }
    .table-center {
      flex: 1;
      align-self: center;
      text-align: center;
      margin: 0 5px;
    }
    .table-right {
      position: relative;
      width: 450px;
      .sup-tips {
        position: absolute;
        top: -22px;
        left: 20px;
        color: #f0250f;
        font-size: 12px;
      }
    }
    .add-sup {
      color: #0064c8;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }

    .del-btn {
      color: #f0250f;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .search-form {
    ::v-deep .el-form-item {
      width: 100%;
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
    }
    ::v-deep .el-select {
      width: 300px;
    }
    ::v-deep .el-input {
      width: auto;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
  }
  .search-box {
    background: #fff;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .search-btn {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }

      .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-right: 30px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        background: #2587ff;
        border: 1px solid #2587ff;
        color: #ffffff;
        &:hover,
        :active {
          background-color: #126edf;
        }
      }
    }
  }
  .tab-content {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 10px;
    border-bottom: 1px solid #d9d9d9;
    .tab-btn {
      position: relative;
      width: 150px;
      height: 34px;
      line-height: 34px;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      color: #606266;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      font-weight: 500;
      padding: 0 20px;
      font-size: 14px;
      border: 1px solid #d9d9d9;
      border-bottom: 0;
      &:last-child {
        border-left: 1px solid #d9d9d9;
      }
      &:first-child {
        border-right: 0;
      }
      &.active {
        background: #f4f7ff;
        color: #0064c8;
        height: 34px;
        line-height: 34px;
        border-top: 0;
        &::after {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          content: '';
          width: 100%;
          height: 2px;
          background: #0064c8;
        }
      }
    }
  }
  .el-checkbox__label {
    font-weight: normal;
  }
  .el-form-item__content {
    width: 300px;
  }
  .el-select {
    width: 300px;
  }
  .range {
    .el-form-item__content {
      display: flex;
      width: 300px;
    }
  }
}
</style>
